<template>
  <v-container flex>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout row wrap v-else>
      <v-flex xs12>
        <v-tabs v-model="tab" grow>
          <v-tabs-slider color="green"></v-tabs-slider>
          <v-tab class="secondary--text title font-weight-bold">Termos de Uso</v-tab>
          <v-tab class="secondary--text title font-weight-bold">Políticas de Privacidade</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item lazy>
            <v-list dense two-line>
              <v-btn
                @click="dialogNovoTermo = true"
                flat
                block
                class="text-xs-center primary--text text-xs-center"
              >ADICIONAR NOVO TERMO</v-btn>
              <template v-for="(termo, index) in termosDeUso">
                <v-divider :key="`divider-${index}`" v-if="index > 0"></v-divider>
                <v-list-tile :key="index" avatar>
                  <v-list-tile-avatar>
                    <v-icon color="green" size="25">assignment</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title class="font-weight-light subheading">Versão: {{termo.versao}}</v-list-tile-title>
                    <v-list-tile-sub-title>Data de inserção {{termo.data_inserido.substr(0, 10).split('-').reverse().join('/')}}</v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action class="mr-3 ml-3">
                    <v-layout align-center column>
                      <v-list-tile-action-text
                        class="grey--text text--darken-2 body-2 font-weight-regular"
                      >Cliente</v-list-tile-action-text>
                      <v-icon :color="termo.cliente ? 'green' : 'grey'">check_circle</v-icon>
                    </v-layout>
                  </v-list-tile-action>
                  <v-list-tile-action class="mr-3 ml-3">
                    <v-layout align-center column>
                      <v-list-tile-action-text
                        class="grey--text text--darken-2 body-2 font-weight-regular"
                      >Frentista</v-list-tile-action-text>
                      <v-icon :color="termo.frentista ? 'green' : 'grey'">check_circle</v-icon>
                    </v-layout>
                  </v-list-tile-action>
                  <v-list-tile-action class="mr-3 ml-3">
                    <v-layout align-center column>
                      <v-list-tile-action-text
                        class="grey--text text--darken-2 body-2 font-weight-regular"
                      >Empresa</v-list-tile-action-text>
                      <v-icon :color="termo.empresa ? 'green' : 'grey'">check_circle</v-icon>
                    </v-layout>
                  </v-list-tile-action>
                  <v-list-tile-action class="mr-3 ml-3">
                    <v-layout align-center column>
                      <v-list-tile-action-text
                        class="grey--text text--darken-2 body-2 font-weight-regular"
                      >Posto</v-list-tile-action-text>
                      <v-icon :color="termo.posto ? 'green' : 'grey'">check_circle</v-icon>
                    </v-layout>
                  </v-list-tile-action>
                  <v-list-tile-action>
                    <v-menu offset-x transition="slide-x-reverse-transition" left lazy>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon size="25" color="grey darken-2">more_vert</v-icon>
                        </v-btn>
                      </template>
                      <v-list class="pa-0">
                        <v-list-tile ripple @click="detalharTermo(termo)">
                          <v-list-tile-content>
                            <v-list-tile-title
                              class="text-xs-center green--text font-weight-light"
                            >VISUALIZAR</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile ripple @click="apagarTermo(termo)">
                          <v-list-tile-content>
                            <v-list-tile-title
                              class="text-xs-center red--text font-weight-light"
                            >APAGAR</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
            <div class="text-xs-center pt-2">
              <v-pagination
                color="info"
                circle
                v-model="termosPagination.page"
                :length="pagesTermos"
              ></v-pagination>
            </div>
          </v-tab-item>
          <v-tab-item lazy>
            <v-list dense two-line>
              <v-btn
                @click="dialogNovaPolitica = true"
                flat
                block
                class="text-xs-center primary--text text-xs-center"
              >ADICIONAR NOVA POLÍTICA</v-btn>
              <template v-for="(politica, index) in politicasDePrivacidade">
                <v-divider :key="`divider-${index}`" v-if="index > 0"></v-divider>
                <v-list-tile :key="index" avatar>
                  <v-list-tile-avatar>
                    <v-icon color="green" size="25">assignment</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title
                      class="font-weight-light subheading"
                    >Versão: {{politica.versao}}</v-list-tile-title>
                    <v-list-tile-sub-title>Data de inserção {{politica.data_inserido.substr(0, 10).split('-').reverse().join('/')}}</v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action class="mr-3 ml-3">
                    <v-layout align-center column>
                      <v-list-tile-action-text
                        class="grey--text text--darken-2 body-2 font-weight-regular"
                      >Cliente</v-list-tile-action-text>
                      <v-icon :color="politica.cliente ? 'green' : 'grey'">check_circle</v-icon>
                    </v-layout>
                  </v-list-tile-action>
                  <v-list-tile-action class="mr-3 ml-3">
                    <v-layout align-center column>
                      <v-list-tile-action-text
                        class="grey--text text--darken-2 body-2 font-weight-regular"
                      >Frentista</v-list-tile-action-text>
                      <v-icon :color="politica.frentista ? 'green' : 'grey'">check_circle</v-icon>
                    </v-layout>
                  </v-list-tile-action>
                  <v-list-tile-action class="mr-3 ml-3">
                    <v-layout align-center column>
                      <v-list-tile-action-text
                        class="grey--text text--darken-2 body-2 font-weight-regular"
                      >Empresa</v-list-tile-action-text>
                      <v-icon :color="politica.empresa ? 'green' : 'grey'">check_circle</v-icon>
                    </v-layout>
                  </v-list-tile-action>
                  <v-list-tile-action class="mr-3 ml-3">
                    <v-layout align-center column>
                      <v-list-tile-action-text
                        class="grey--text text--darken-2 body-2 font-weight-regular"
                      >Posto</v-list-tile-action-text>
                      <v-icon :color="politica.posto ? 'green' : 'grey'">check_circle</v-icon>
                    </v-layout>
                  </v-list-tile-action>
                  <v-list-tile-action>
                    <v-menu offset-x transition="slide-x-reverse-transition" left lazy>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon size="25" color="grey darken-2">more_vert</v-icon>
                        </v-btn>
                      </template>
                      <v-list class="pa-0">
                        <v-list-tile ripple @click="detalharPolitica(politica)">
                          <v-list-tile-content>
                            <v-list-tile-title
                              class="text-xs-center green--text font-weight-light"
                            >VISUALIZAR</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile ripple @click="apagarPolitica(politica)">
                          <v-list-tile-content>
                            <v-list-tile-title
                              class="text-xs-center red--text font-weight-light"
                            >APAGAR</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
            <div class="text-xs-center pt-2">
              <v-pagination
                color="info"
                circle
                v-model="politicasPagination.page"
                :length="pagesPoliticas"
              ></v-pagination>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
    <v-dialog lazy width="500" v-model="dialogNovoTermo" persistent>
      <novo-termo @fechar="dialogNovoTermo = false" @info="carregarDados()"></novo-termo>
    </v-dialog>
    <v-dialog lazy width="600" v-model="dialogNovaPolitica" persistent>
      <nova-politica @fechar="dialogNovaPolitica = false" @info="carregarDados()"></nova-politica>
    </v-dialog>
    <v-dialog lazy width="500" :value="dialogReady" persistent>
      <detalhes-termo-politica></detalhes-termo-politica>
    </v-dialog>
  </v-container>
</template>

<script>

import SmartLockMessage from '@/components/SmartLockMessage'
const NovoTermo = () => import('../../components/cadastros/CadTermoUso')
const NovaPolitica = () =>
  import('../../components/cadastros/CadPoliticaPrivacidade')
const DetalhesTermoPolitica = () =>
  import('../../components/dialogs/DialogDetalhesTermoPolitica')

export default {
  components: {
    NovoTermo,
    NovaPolitica,
    DetalhesTermoPolitica,
    SmartLockMessage
  },
  data () {
    return {
      tab: null,
      dialogNovoTermo: false,
      dialogNovaPolitica: false,
      termosPagination: {
        page: 1,
        rowsPerPage: 5,
        totalItems: 0
      },
      politicasPagination: {
        page: 1,
        rowsPerPage: 5,
        totalItems: 0
      }
    }
  },
  watch: {
    'termosPagination.page' (val) {
      if (val) {
        this.carregarDados()
      }
    },
    'politicasPagination.page' (val) {
      if (val) {
        this.carregarDados()
      }
    },
    headers (val) {
      if (val) {
        this.carregarDados()
      }
    }
  },
  mounted () {
    if (this.headers) {
      this.carregarDados()
    }
  },
  computed: {
    termoSelected () {
      return this.$store.getters.termoSelected
    },
    politicaSelected () {
      return this.$store.getters.politicaSelected
    },
    smartLock () {
      return this.$store.getters.smartLock
    },
    dialogReady () {
      return !!this.termoSelected || !!this.politicaSelected
    },
    pagesTermos () {
      if (
        this.termosPagination.rowsPerPage == null ||
        this.termosPagination.totalItems == null
      ) {
        return 0
      }

      return Math.ceil(
        this.termosPagination.totalItems / this.termosPagination.rowsPerPage
      )
    },
    pagesPoliticas () {
      if (
        this.politicasPagination.rowsPerPage == null ||
        this.politicasPagination.totalItems == null
      ) {
        return 0
      }

      return Math.ceil(
        this.politicasPagination.totalItems /
          this.politicasPagination.rowsPerPage
      )
    },
    headers () {
      return this.$store.getters.headers
    },
    termosDeUso () {
      return this.$store.getters.termosDeUso
    },
    politicasDePrivacidade () {
      return this.$store.getters.politicasDePrivacidade
    }
  },
  methods: {
    carregarDados () {
      this.$store
        .dispatch('loadTermoDeUso', this.termosPagination)
        .then(totalItems => {
          this.termosPagination.totalItems = totalItems
        })
      this.$store
        .dispatch('loadPoliticasDePrivacidade', this.politicasPagination)
        .then(totalItems => {
          this.politicasPagination.totalItems = totalItems
        })
    },
    apagarTermo (termo) {
      this.$store.dispatch('apagarTermoDeUso', termo.id).then(() => {
        this.carregarDados()
      })
    },
    detalharTermo (termo) {
      this.$store.dispatch('detalhesTermoDeUso', termo.id)
    },
    apagarPolitica (politica) {
      this.$store
        .dispatch('apagarPoliticasDePrivacidade', politica.id)
        .then(() => {
          this.carregarDados()
        })
    },
    detalharPolitica (politica) {
      this.$store.dispatch('detalhesPoliticaDePrivacidade', politica.id)
    }
  }
}
</script>
